import { cn } from '../lib/cn'

const TONES = ['bg-cat-1', 'bg-cat-2', 'bg-cat-3', 'bg-cat-4', 'bg-cat-5', 'bg-cat-6'] as const

function hash(s: string): number {
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0
  return Math.abs(h)
}

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/)
  const first = parts[0]?.[0] ?? '?'
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : ''
  return (first + last).toUpperCase()
}

/** Initials avatar. Colour is a stable hash of the name; Riley always gets its own token. */
export function Avatar({
  name,
  size = 'md',
  riley = false,
  className,
}: {
  name: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
  riley?: boolean
  className?: string
}) {
  const sizes = { xs: 'size-5 text-[9px]', sm: 'size-6 text-2xs', md: 'size-8 text-xs', lg: 'size-10 text-sm' }
  return (
    <span
      role="img"
      aria-label={name}
      title={name}
      className={cn(
        'inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold text-white',
        riley ? 'bg-riley' : TONES[hash(name) % TONES.length],
        sizes[size],
        className,
      )}
    >
      {riley ? 'R' : initialsOf(name)}
    </span>
  )
}
